// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pvC70WnLH9fb0D {
  z-index: 10;
  margin: 0 2px;
  border-radius: 16px;
  background-color: var(--ds-surface-raised, #ffffff);
}
.pvC70WnLH9fb0D:hover {
  background-color: var(--ds-surface-raised-hovered, #f1f2f4);
}
.pvC70WnLH9fb0D:active {
  background-color: var(--ds-surface-raised-pressed, #dcdfe4);
}
.pvC70WnLH9fb0D > span > svg {
  width: 14px;
  height: 14px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"archiveButton": `pvC70WnLH9fb0D`
};
export default ___CSS_LOADER_EXPORT___;
